<script setup>
const steps = [
  { t: 'Уточнение ситуации', d: 'Выслушаем и зафиксируем суть вашего дела' },
  { t: 'Запрос документов', d: 'Подскажем, что собрать и как' },
  { t: 'Анализ', d: 'Оценим перспективы и риски' },
  { t: 'Консультация', d: 'План действий и стоимость' },
  { t: 'Заключение договора', d: 'Фиксируем объём работ и цену' },
  { t: 'Работа', d: 'Документы, переговоры, суд' },
  { t: 'Результат', d: 'Доводим дело до решения' },
  { t: 'Отзыв', d: 'Остаёмся на связи после' },
];
</script>

<template>
  <section id="steps" class="bg-slate-50 scroll-mt-24">
    <div class="max-w-7xl mx-auto px-4 py-8 md:py-12">
      <div class="flex items-center gap-3 mb-7">
        <span class="flex-grow h-px bg-gray-200"></span>
        <h2 class="text-2xl lg:text-3xl font-extrabold tracking-tight text-gray-900 text-center">Как мы работаем</h2>
        <span class="flex-grow h-px bg-gray-200"></span>
      </div>

      <ol class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-8 gap-4">
        <li
          v-for="(s, i) in steps"
          :key="i"
          class="relative flex sm:flex-col gap-3 rounded-xl bg-white border border-gray-100 p-4 hover:border-indigo-200 hover:shadow-sm transition-all"
        >
          <span class="shrink-0 flex items-center justify-center w-10 h-10 rounded-full bg-indigo-600 text-white font-bold">
            {{ i + 1 }}
          </span>
          <div>
            <h3 class="font-semibold text-gray-900 text-sm leading-tight">{{ s.t }}</h3>
            <p class="text-xs text-gray-500 mt-1 leading-snug">{{ s.d }}</p>
          </div>
        </li>
      </ol>
    </div>
  </section>
</template>
